module.exports = __webpack_public_path__ + "img/ai_teacher_Sarah.7ce216ee.png";